import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";

import Select from "../components/Select";
import InputNumber from "../components/InputNumber";
import Output from "../components/Output";

import { timberTension } from "../../utils/services/calculators";
import { Text, useToast } from "@chakra-ui/react";

function TimberTension({}) {
  const toast = useToast();
  // BENDING
  const [tensionInputs, setTensionInputs] = useState({
    forest_type: "Nativa",
    timber: "Coníferas",
    timber_class: "D20",
    timber_type: "Madeira serrada",
    load_class: "Permanente",
    moisture_class: "1 (≤ 65%)",
    lx: "",
    ke_x: 1,
    ly: "",
    ke_y: 1,
    b: "",
    h: "",
    af: "",
    nsd: "",
  });
  const [tensionOutputs, setTensionOutputs] = useState({
    ft0_d: "",
    l0_x: "",
    l0_y: "",
    tens_nt_d: "",
    memorial: {},
  });

  function updateTensionInputs(name, value) {
    if (
      name === "forest_type" ||
      name === "timber" ||
      name === "timber_class" ||
      name === "timber_type" ||
      name === "load_class" ||
      name === "moisture_class"
    ) {
      if (value === "Nativa") {
        setTensionInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D20",
        }));
      } else if (value === "Plantada") {
        setTensionInputs((prevInputs) => ({
          ...prevInputs,
          ["timber"]: "Coníferas",
        }));
        setTensionInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      }
      if (value === "Coníferas") {
        setTensionInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      } else if (value === "Folhosas") {
        setTensionInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D18",
        }));
      }
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else if (value === "") {
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setTensionOutputs({
      ft0_d: "",
      l0_x: "",
      l0_y: "",
      tens_nt_d: "",
    });
  }

  function onTensionCalculate() {
    if (
      tensionInputs["lx"] === "" ||
      tensionInputs["ly"] === "" ||
      tensionInputs["b"] === "" ||
      tensionInputs["h"] === "" ||
      tensionInputs["af"] === "" ||
      tensionInputs["nsd"] === ""
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      tensionInputs["lx"] === 0 ||
      tensionInputs["ly"] === 0 ||
      tensionInputs["b"] === 0 ||
      tensionInputs["h"] === 0 ||
      tensionInputs["nsd"] === 0
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else {
      timberTension(tensionInputs).then((response) => {
        setTensionOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "timber-tension-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", { page: "timber-tension-calculator" });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Tração:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Floresta"
              elements={["Nativa", "Plantada"]}
              unit=""
              onChange={(e) =>
                updateTensionInputs("forest_type", e.target.value)
              }
              value={tensionInputs["forest_type"]}
            />
            {tensionInputs["forest_type"] === "Plantada" && (
              <Select
                text="Madeira"
                elements={["Coníferas", "Folhosas"]}
                unit=""
                onChange={(e) => updateTensionInputs("timber", e.target.value)}
                value={tensionInputs["timber"]}
              />
            )}
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Classe"
              elements={
                tensionInputs["forest_type"] === "Nativa"
                  ? ["D20", "D30", "D40", "D50", "D60"]
                  : tensionInputs["forest_type"] === "Plantada" &&
                      tensionInputs["timber"] === "Coníferas"
                    ? [
                        "C14",
                        "C16",
                        "C18",
                        "C20",
                        "C22",
                        "C24",
                        "C27",
                        "C30",
                        "C35",
                        "C40",
                        "C45",
                        "C50",
                      ]
                    : tensionInputs["forest_type"] === "Plantada" &&
                        tensionInputs["timber"] === "Folhosas"
                      ? ["D18", "D24", "D30", "D35", "D40", "D50", "D60", "D70"]
                      : []
              }
              unit=""
              onChange={(e) =>
                updateTensionInputs("timber_class", e.target.value)
              }
              value={tensionInputs["timber_class"]}
            />
            <Select
              text="Classe de umid."
              elements={["1 (≤ 65%)", "2 (≤ 75%)", "3 (≤ 85%)", "4 (> 85%)"]}
              unit=""
              onChange={(e) =>
                updateTensionInputs("moisture_class", e.target.value)
              }
              value={tensionInputs["moisture_class"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Tipo"
              elements={[
                "Madeira serrada",
                "Madeira roliça",
                "Madeira lamelada colada (MLC)",
                "Madeira lamelada colada cruzada (MLCC)",
                "Madeira laminada colada (LVL)",
                "Madeira recomposta",
              ]}
              unit=""
              onChange={(e) =>
                updateTensionInputs("timber_type", e.target.value)
              }
              value={tensionInputs["timber_type"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Classe de carregamento"
              elements={[
                "Permanente",
                "Longa duração",
                "Média duração",
                "Curta duração",
                "Instantânea",
              ]}
              unit=""
              onChange={(e) =>
                updateTensionInputs("load_class", e.target.value)
              }
              value={tensionInputs["load_class"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Lx"
              unit="cm"
              onChange={(e) => updateTensionInputs("lx", e.target.value)}
            />
            <Select
              text="Kex"
              elements={[0.65, 0.8, 1.2, 1, 2.1, 2.4]}
              unit=""
              onChange={(e) => updateTensionInputs("ke_x", e.target.value)}
              value={tensionInputs["ke_x"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Ly"
              unit="cm"
              onChange={(e) => updateTensionInputs("ly", e.target.value)}
            />
            <Select
              text="Key"
              elements={[0.65, 0.8, 1.2, 1, 2.1, 2.4]}
              unit=""
              onChange={(e) => updateTensionInputs("ke_y", e.target.value)}
              value={tensionInputs["ke_y"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="b"
              unit="cm"
              onChange={(e) => updateTensionInputs("b", e.target.value)}
            />
            <InputNumber
              text="h"
              unit="cm"
              onChange={(e) => updateTensionInputs("h", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="af"
              unit="cm²"
              onChange={(e) => updateTensionInputs("af", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Nsd"
              unit="tf"
              onChange={(e) => updateTensionInputs("nsd", e.target.value)}
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onTensionCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <div className={styles.outputRow}>
            <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          </div>
          <Output text="ft0,d" value={tensionOutputs["ft0_d"]} unit="MPa" />
          {tensionOutputs["l0_x"] === "" ? (
            <h4 className={styles.rowDescription}>L0,x =</h4>
          ) : (
            <h4 className={styles.rowDescription}>
              {"L0,x = " +
                tensionOutputs["l0_x"].toFixed(2) +
                " ≤ " +
                (50 * tensionInputs["h"]).toFixed(2) +
                " → "}
              {tensionOutputs["l0_x"] <= 50 * tensionInputs["h"]
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
          {tensionOutputs["l0_y"] === "" ? (
            <h4 className={styles.rowDescription}>L0,y =</h4>
          ) : (
            <h4 className={styles.rowDescription}>
              {"L0,y = " +
                tensionOutputs["l0_y"].toFixed(2) +
                " ≤ " +
                (50 * tensionInputs["b"]).toFixed(2) +
                " → "}
              {tensionOutputs["l0_y"] <= 50 * tensionInputs["b"]
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
          <Output text="σNt,d" value={tensionOutputs["tens_nt_d"]} unit="MPa" />
          {tensionOutputs["tens_nt_d"] !== "" && (
            <h4 className={styles.rowDescription}>
              {tensionOutputs["tens_nt_d"].toFixed(2) +
                " ≤ " +
                tensionOutputs["ft0_d"].toFixed(2) +
                " → "}
              {tensionOutputs["tens_nt_d"] <= tensionOutputs["ft0_d"].toFixed(2)
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {tensionOutputs["memorial"] &&
          Object.entries(tensionOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default TimberTension;
